import {GenericTransformer} from './GenericTransformer';
import {Injectable} from '@angular/core';
import {Address} from '../domain/address';
import {GetAddressIoAddress} from '../core/address-lookup.service';

@Injectable()
export class GetAddressIoAddressToAddressTransformer implements GenericTransformer<GetAddressIoAddress, Address> {

    transform(from: GetAddressIoAddress): Address {
        const address = {
            line1: from.line_1,
            line2: from.line_2,
            line3: from.line_3,
            line4: from.line_4,
            locality: from.locality,
            town: from.town_or_city,
            county: from.county,
            latitude: from.latitude,
            longitude: from.longitude,
            postCode: from.postcode,
            country: from.country
        };
        return new Address(address);
    }
}
